import { render, staticRenderFns } from "./RiskControlInfoDialog.vue?vue&type=template&id=fe007578&scoped=true"
import script from "./RiskControlInfoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RiskControlInfoDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RiskControlInfoDialog.vue?vue&type=style&index=0&id=fe007578&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe007578",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe007578')) {
      api.createRecord('fe007578', component.options)
    } else {
      api.reload('fe007578', component.options)
    }
    module.hot.accept("./RiskControlInfoDialog.vue?vue&type=template&id=fe007578&scoped=true", function () {
      api.rerender('fe007578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/finance/components/RiskControlInfoDialog.vue"
export default component.exports